var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#39393C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0713 18.0151H23.4903C23.6955 18.0151 23.9155 18.1066 24.043 18.2456L24.0438 18.2448C24.1854 18.3864 24.2734 18.5825 24.2734 18.7981V24.2172C24.2734 24.6485 23.9201 25.0004 23.4903 25.0004H18.0713C17.8661 25.0004 17.6461 24.9089 17.5187 24.7699L17.5178 24.7707C17.3762 24.6291 17.2882 24.4332 17.2882 24.2174V18.7981C17.2882 18.3668 17.6417 18.0151 18.0713 18.0151ZM7.78317 18.0151H13.2023C13.6338 18.0151 13.9855 18.3668 13.9855 18.7983V24.2172C13.9855 24.6487 13.6338 25.0004 13.2023 25.0004H7.78317C7.35189 25.0004 7 24.6489 7 24.2172V18.7981C7 18.3668 7.35169 18.0151 7.78317 18.0151ZM21.3088 7.21871L24.7817 10.6916C25.0728 10.9826 25.0728 11.4563 24.7817 11.7474L21.3088 15.2203C21.0083 15.5208 20.5103 15.4996 20.2536 15.2195L20.2528 15.2203L16.7516 11.7159C16.4798 11.3967 16.5107 10.94 16.7807 10.6924L16.7799 10.6916L20.2845 7.19023C20.5958 6.925 21.0297 6.93954 21.3088 7.21871ZM7.78317 7.72675H13.2023C13.6338 7.72675 13.9855 8.07844 13.9855 8.50991V13.9291C13.9855 14.3605 13.6338 14.7122 13.2023 14.7122H7.78317C7.35189 14.7122 7 14.3607 7 13.9291V8.50991C7 8.07844 7.35169 7.72675 7.78317 7.72675Z",
    fill: "#FF9747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame25);
export default __webpack_public_path__ + "static/media/Frame 25.64a536124032fc00266baf616099a991.svg";
export { ForwardRef as ReactComponent };